import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bosch-ui-card',
  imports: [CommonModule],
  templateUrl: './bosch-ui-card.component.html',
  styleUrls: ['./bosch-ui-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiCardComponent {}
